import CryptoJS from 'crypto-js';

export function generateToken(userID: string, seconds: number = 7200): string {
    if (!userID) {
        console.error('UserID tidak boleh kosong.');
        return '';
    }

    // Membangun data yang akan dienkripsi
    const time = Math.floor(Date.now() / 1000); // Mengambil waktu saat ini dalam detik
    const body = {
        app_id: Number(process.env.REACT_APP_ZEGOCLOUD_APP_ID),
        user_id: userID,
        nonce: Math.floor(Math.random() * 2147483647),
        ctime: time,
        expire: time + seconds, // Masa berlaku token
    };

    // Enkripsi data
    const key = CryptoJS.enc.Utf8.parse('3a465d4d268f99089979bcc6ff58ef34');
    let iv = Math.random().toString().substring(2, 18);
    if (iv.length < 16) {
        iv = iv.padEnd(16, iv); // Memastikan panjang IV adalah 16 karakter
    }

    const ciphertext = CryptoJS.AES.encrypt(JSON.stringify(body), key, {
        iv: CryptoJS.enc.Utf8.parse(iv),
    }).toString();

    // Mengonversi ciphertext menjadi Uint8Array
    const ciphert = new Uint8Array(Array.from(atob(ciphertext)).map((val) => val.charCodeAt(0)));
    const len_ciphert = ciphert.length;

    // Membangun data token
    const uint8 = new Uint8Array(8 + 2 + 16 + 2 + len_ciphert);
    // expire: 8
    uint8.set([0, 0, 0, 0]);
    uint8.set(new Uint8Array(new Int32Array([body.expire]).buffer).reverse(), 4);
    // iv length: 2
    uint8[8] = iv.length >> 8;
    uint8[9] = iv.length - (uint8[8] << 8);
    // iv: 16
    uint8.set(new Uint8Array(Array.from(iv).map((val) => val.charCodeAt(0))), 10);
    // ciphertext length: 2
    uint8[26] = len_ciphert >> 8;
    uint8[27] = len_ciphert - (uint8[26] << 8);
    // ciphertext
    uint8.set(ciphert, 28);

    // Mengonversi Uint8Array ke string base64
    const token = `04${btoa(String.fromCharCode(...uint8))}`;
    console.log('generateToken', iv.length, body, token);

    return token;
}
